import { render } from "./AttachmentTile.vue?vue&type=template&id=3401e198&scoped=true"
import script from "./AttachmentTile.vue?vue&type=script&lang=js"
export * from "./AttachmentTile.vue?vue&type=script&lang=js"

import "./AttachmentTile.vue?vue&type=style&index=0&id=3401e198&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3401e198"]])

export default __exports__